export default __webpack_public_path__ + "static/media/3.f11cf8b0.png";